import { RepositoryFactory } from "@/data/repositories/repositoryFactory";

const state = {
    runs: [],
    loading: false,
    error: null
};

const getters = {
    runs: state => state.runs,
    loading: state => state.loading,
    error: state => state.error
};

const actions = {
    async fetchRecentRuns({ commit }, count = 100) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const response = await RepositoryFactory.get("processRun").getRecentRuns(count);
            commit("SET_RUNS", response.data);
        } catch (error) {
            commit("SET_ERROR", error.message || "Prosessien haku epäonnistui");
        } finally {
            commit("SET_LOADING", false);
        }
    }
};

const mutations = {
    SET_RUNS(state, runs) { state.runs = runs; },
    SET_LOADING(state, val) { state.loading = val; },
    SET_ERROR(state, val) { state.error = val; }
};

export default { namespaced: true, state, getters, actions, mutations };
